// EdgeProfiles.ts
import * as THREE from 'three';
export const DefaultEdgeProfile = {
    name: 'default',
    style: {
        color: 0x2196f3,
        opacity: 1.0,
        widthPx: 4,
        dashed: false,
        dashScale: 1,
        extraOffsetStart: 0,
        extraOffsetEnd: 0,
        distanceStyle: undefined
    },
    curve: {
        mode: 'straight',
        bend: 0.0,
        controlPoint: null,
        controlStrategy: 'midNormal',
        segments: 16
    },
    arrows: {
        start: false,
        end: false,
        size: 12,
        twoSided: false,
        facing: 'towardTarget'
    },
    label: {
        text: '',
        atT: 0.5,
        spriteScale: 32
    },
    elastic: {
        enabled: false,
        rest: 'surface',
        stiffness: 0.0,
        damping: 0.0,
        maxForce: 1e9,
        minSeparation: 5,
        minRestLength: 20,
        maxDistance: undefined,
        transverseDamping: 1.5 // ⬅ off by default
    }
};
export function mergeEdgeProfiles(base, override) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const a = base !== null && base !== void 0 ? base : {};
    const b = override !== null && override !== void 0 ? override : {};
    return {
        name: (_a = b.name) !== null && _a !== void 0 ? _a : a.name,
        style: Object.assign(Object.assign({}, ((_b = a.style) !== null && _b !== void 0 ? _b : {})), ((_c = b.style) !== null && _c !== void 0 ? _c : {})),
        curve: Object.assign(Object.assign({}, ((_d = a.curve) !== null && _d !== void 0 ? _d : {})), ((_e = b.curve) !== null && _e !== void 0 ? _e : {})),
        arrows: Object.assign(Object.assign({}, ((_f = a.arrows) !== null && _f !== void 0 ? _f : {})), ((_g = b.arrows) !== null && _g !== void 0 ? _g : {})),
        label: Object.assign(Object.assign({}, ((_h = a.label) !== null && _h !== void 0 ? _h : {})), ((_j = b.label) !== null && _j !== void 0 ? _j : {})),
        elastic: Object.assign(Object.assign({}, ((_k = a.elastic) !== null && _k !== void 0 ? _k : {})), ((_l = b.elastic) !== null && _l !== void 0 ? _l : {})),
    };
}
export function mapDistance(dm, d) {
    const t = THREE.MathUtils.clamp((d - dm.far) / (dm.near - dm.far), 0, 1);
    return THREE.MathUtils.lerp(dm.min, dm.max, t);
}
